<!-- 开题报告 -->
<template>
  <svg
    t="1748246729487"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="18513"
    width="200"
    height="200"
  >
    <path
      d="M0 0m307.2 0l409.6 0q307.2 0 307.2 307.2l0 409.6q0 307.2-307.2 307.2l-409.6 0q-307.2 0-307.2-307.2l0-409.6q0-307.2 307.2-307.2Z"
      fill="#D76EE5"
      p-id="18514"
    />
    <path
      d="M768 380.3648L597.3504 204.8H329.1648C288.7168 204.8 256 239.2064 256 281.6v460.8c0 42.3936 32.768 76.8 73.1648 76.8h365.6704c40.448 0 73.1648-34.4064 73.1648-76.8V380.3648zM640 537.6c0 14.1312-9.5744 25.6-21.3504 25.6H405.3504c-11.776 0-21.3504-11.4688-21.3504-25.6s9.5744-25.6 21.3504-25.6h213.2992c11.776 0 21.3504 11.4688 21.3504 25.6z m-21.3504 128c11.776 0 21.3504 11.4688 21.3504 25.6s-9.5744 25.6-21.3504 25.6H405.3504c-11.776 0-21.3504-11.4688-21.3504-25.6s9.5744-25.6 21.3504-25.6h213.2992z m7.168-285.2352a28.8768 28.8768 0 0 1-28.4672-29.2864V266.8544l110.336 113.5104h-81.92z"
      fill="#FFFFFF"
      p-id="18515"
    />
  </svg>
</template>
